import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section aria-labelledby="hero-title" className="border-b border-line" data-id="element-91" data-mp="oh9j8xlbydtl">
      <div className="mx-auto grid max-w-site gap-12 px-6 pb-16 pt-14 lg:grid-cols-12 lg:gap-10 lg:px-10 lg:pb-24 lg:pt-20" data-id="element-92" data-mp="jogdq7i1f1gg">
        <div className="flex flex-col lg:col-span-7 lg:pr-6" data-id="element-93" data-mp="eplz7hr3rz25">
          <p className="text-[15px] text-accent" data-id="element-94" data-mp="ap351h1qmgws">Conseil en habitat et renouvellement urbain</p>
          <h1 id="hero-title" className="mt-6 font-serif text-[2.6rem] leading-[1.08] tracking-tight text-ink sm:text-6xl lg:text-[4.25rem]" data-id="element-95" data-mp="5oxkslxsrwoq">
            Accompagner les territoires dans la fabrique d’une ville habitable.
          </h1>
          <p className="mt-8 max-w-xl text-lg leading-relaxed text-muted" data-id="element-96" data-mp="3rz1jt0dj863e">
            Depuis vingt ans, nous conseillons les collectivités, bailleurs et opérateurs publics dans la
            conception, le pilotage et l’évaluation de leurs politiques de l’habitat et de leurs projets urbains.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-97" data-mp="1rvfiq1crhzav">
            <Link to="/expertises" className="inline-flex items-center justify-center gap-3 whitespace-nowrap bg-ink px-7 py-4 text-[15px] text-paper transition-colors duration-150 hover:bg-ink-soft" data-id="element-98" data-mp="1rt2q8u9do6jk">
              Découvrir nos expertises
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-99" data-mp="25nlwxhwctw7o" />
            </Link>
            <Link to="/references" className="inline-flex items-center justify-center whitespace-nowrap border border-ink px-7 py-4 text-[15px] text-ink transition-colors duration-150 hover:bg-ink hover:text-paper" data-id="element-100" data-mp="2aldp8d0wvkce">
              Voir nos références
            </Link>
          </div>

          <dl className="mt-auto grid grid-cols-3 gap-6 border-t border-line pt-8 max-lg:mt-14" data-id="element-101" data-mp="2ojv89xfvg8nz">
            <div data-id="element-102" data-mp="2tehi3w6b1t5y">
              <dt className="text-sm text-muted" data-id="element-103" data-mp="338ev1k8vaq1m">Territoires accompagnés</dt>
              <dd className="mt-1 font-serif text-3xl text-ink" data-id="element-104" data-mp="336ao0tfo9ax4">180+</dd>
            </div>
            <div data-id="element-105" data-mp="2ya3llamhihjx">
              <dt className="text-sm text-muted" data-id="element-106" data-mp="2y7h8kvgtr9ub">Projets ANRU pilotés</dt>
              <dd className="mt-1 font-serif text-3xl text-ink" data-id="element-107" data-mp="2u5vs70530dfd">34</dd>
            </div>
            <div data-id="element-108" data-mp="2p83zi3wm4na4">
              <dt className="text-sm text-muted" data-id="element-109" data-mp="2paq7u5rbv6te">Années d’expérience</dt>
              <dd className="mt-1 font-serif text-3xl text-ink" data-id="element-110" data-mp="2kaauvfayk1by">20</dd>
            </div>
          </dl>
        </div>

        <figure className="lg:col-span-5" data-id="element-111" data-mp="2fhhpqqbkuqzc">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/feda165a-2ddf-45d5-bf0e-8566b3e87b59.jpg" alt="Quartier résidentiel réhabilité avec une place arborée où se promènent des habitants" className="aspect-[4/5] w-full object-cover" data-id="element-112" data-mp="2ajg5i22f0lma" />
          <figcaption className="mt-3 text-sm text-muted" data-id="element-113" data-mp="1wjew1y8345v7">
            Quartier réhabilité dans le cadre d’un programme de renouvellement urbain.
          </figcaption>
        </figure>
      </div>
    </section>;
}